import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import {
  PARAM_STARTUPS_LIKES_PATH,
  STATUS_TYPE_LIST,
} from "src/app/admin/constants/constants";
import { AbstractListController } from "../../common/abstract-list.component";
import { Startups_likes } from "src/app/models/startups_likes";
import { StartupsLikesService } from "src/app/services/startups_likes.service";
import { CommonModule } from "@angular/common";
import { DataTableComponent } from "../../common/data-table/data-table.component";
import {
  TableColumn,
  TableFilter,
} from "../../common/data-table/data-table.model";

@Component({
  standalone: true,
  selector: "app-manage-likes",
  templateUrl: "./manage-likes.component.html",
  imports: [CommonModule, DataTableComponent],
})
export class ManageLikesComponent extends AbstractListController<
  Startups_likes,
  any
> {
  title = "Likes";

  tableColumns: TableColumn[] = [
    { field: "id", header: "ID", width: "80px" },
    { field: "user", header: "User", value: (row) => row.user?.username },
    {
      field: "startups",
      header: "Startup",
      type: "link",
      value: (row) => row.startups?.startup_name || "missing",
      link: (row) =>
        row.startups ? ["/admin/startups/edit", row.startups.id] : null,
    },
  ];

  tableFilters: TableFilter[] = [
    { field: "id", header: "ID", type: "string" },
    { field: "user_email", header: "Email", type: "string" },
    {
      field: "is_active",
      header: "Attivo",
      type: "select",
      options: STATUS_TYPE_LIST,
    },
  ];

  constructor(
    private startupsLikesService: StartupsLikesService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(
      startupsLikesService,
      confirmationService,
      router,
      route,
      PARAM_STARTUPS_LIKES_PATH,
    );
    this.useTableFilters = true;
  }
}
